export default {
  menu: {
    home: 'Home',
    product: 'Product',
    about: 'About',
    login: 'Sign in',
    register: 'Register'
  },
  action: {
    switchLanguage: 'Switch Language Success'
  }
}
